export const appConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api/v1',
  tokenStorageKey: 'daily-report.auth',
} as const;
